import { shallowEqual, useSelector } from 'react-redux';
import { get } from 'lodash';
import { RootState } from 'modules';
import { Moment } from 'moment';
import momentTZ from 'moment-timezone';

export function useTimezone(): [(data: string) => Moment, string] {
  const currentUser = useSelector((state: RootState) => state.user.current_user, shallowEqual);
  const timezone = get(currentUser, 'timezone', Intl.DateTimeFormat().resolvedOptions().timeZone);

  function getDateTime(datetimeString: string) {
    if (datetimeString) {
      return momentTZ(datetimeString).tz(timezone);
    }

    return momentTZ().tz(timezone);
  }

  return [getDateTime, timezone];
}
